import axios from 'axios';
import { store } from '../../App';

// export const baseURL = 'https://internal-ccms.cbn.gov.ng/api';
export const baseURL = process.env.NODE_ENV == 'development' ? process.env.REACT_APP_BASE_URL_TEST : `${window.location.origin}/api`;

const $axios = axios.create({
    baseURL,
});

$axios.interceptors.request.use((config) => {
    const user = store?.getState()?.user?.userData || {};
    config.headers['Authorization'] = 'Bearer ' + user?.token || '';

    return config;
});

$axios.interceptors.response.use(
    (request) => {
        return Promise.resolve(request.data);
    },
    (error) => {
        if (error?.response?.status === 401 || error?.status === 401) {
            localStorage.removeItem('ccms-user');
            window.location.href = '/login';
            return Promise.reject({ message: 'Unauthorized' });
        } else {
            return Promise.reject(error?.response?.data ?? { message: 'An error occurred' });
        }
    }
);

export { $axios };
